import Vue from 'vue';

export const citySelectorEventBus = new Vue();

export const addressChangedEventBus = new Vue();

export const filterEventBus = new Vue();

export const reviewChangedEventBus = new Vue();

export const questionChangedEventBus = new Vue();

export const cashPaymentChangedEventBus = new Vue();

export const chequePaymentChangedEventBus = new Vue();